import axios from 'axios';
import {
  LIST_CATEGORY_URL_OPTIMIZE,
  LIST_CATEGORY_WITH_UNCATEGORIZED_URL_OPTIMIZE,
} from './constants';

export function getCategories() {
  return axios
    .get(LIST_CATEGORY_URL_OPTIMIZE, { withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getCategoriesWithUncategorized() {
  return axios
    .get(LIST_CATEGORY_WITH_UNCATEGORIZED_URL_OPTIMIZE, {
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
